// Credits for the CC-BY 3D models, the interface's type and icons, opened from the menu and from Help. The model list matches docs/3d-assets.md.

// Poly Pizza models are CC BY 3.0, Sketchfab's CC Attribution models are CC BY 4.0.
const SITES = {
  Sketchfab: { url: 'https://sketchfab.com', licence: 'CC BY 4.0', licenceUrl: 'https://creativecommons.org/licenses/by/4.0/' },
  'Poly Pizza': { url: 'https://poly.pizza', licence: 'CC BY 3.0', licenceUrl: 'https://creativecommons.org/licenses/by/3.0/' },
} as const;

/** [what it is in the game, model title, author, where it came from] */
const MODELS: [string, string, string, keyof typeof SITES][] = [
  ['Recon UAV', 'Stinger Drone', 'Aaron Clifford', 'Poly Pizza'],
  ['Loitering Munition', 'Dron low poly 3d model', '3dAssatsForGames', 'Sketchfab'],
  ['Oil Derrick', 'Oil pump', 'Poly by Google', 'Poly Pizza'],
  ['Shipyard crane', 'Building construction crane', 'Kieran Farr', 'Poly Pizza'],
  ['Sniper Nest', 'Watch Tower', 'edminchi', 'Sketchfab'],
  ['Missile Defence', 'Missile Launcher', 'EvesStudio2008', 'Sketchfab'],
];

const esc = (s: string) => s.replace(/[&<>"]/g, c => `&${{ '&': 'amp', '<': 'lt', '>': 'gt', '"': 'quot' }[c]};`);

export function openCredits(): void {
  if (document.getElementById('credits')) return;
  const wrap = document.createElement('div');
  wrap.id = 'credits';
  wrap.className = 'dialog';
  const items = MODELS.map(([what, title, author, site]) => {
    const s = SITES[site];
    return `<li><strong>${esc(what)}</strong>: “${esc(title)}” by ${esc(author)} (<a href="${s.url}" target="_blank" rel="noopener">${site}</a>, `
      + `<a href="${s.licenceUrl}" target="_blank" rel="noopener">${s.licence}</a>)</li>`;
  }).join('');
  wrap.innerHTML = `<div class="box" role="dialog" aria-modal="true" aria-labelledby="credits-title">
    <h2 id="credits-title">Credits</h2>
    <p>These 3D models are used under Creative Commons Attribution licences, each named next to it.
      Every other model in the game is CC0 or made for it.</p>
    <ul class="credits">${items}</ul>
    <h3>Interface</h3>
    <ul class="credits">
      <li>Type: <a href="https://github.com/jpt/barlow" target="_blank" rel="noopener">Barlow</a> by Jeremy Tribby and
        <a href="https://www.jetbrains.com/lp/mono/" target="_blank" rel="noopener">JetBrains Mono</a>, both under the SIL Open Font License, served by Google Fonts.</li>
      <li>Icons drawn after <a href="https://lucide.dev" target="_blank" rel="noopener">Lucide</a> (ISC licence).</li>
    </ul>
    <div class="row"><button class="close primary">Close</button></div>
  </div>`;
  const close = () => wrap.remove();
  (wrap.querySelector('.close') as HTMLButtonElement).onclick = close;
  wrap.addEventListener('click', e => { if (e.target === wrap) close(); });
  wrap.addEventListener('keydown', e => { if (e.key === 'Escape') close(); e.stopPropagation(); });
  document.body.appendChild(wrap);
  (wrap.querySelector('.close') as HTMLButtonElement).focus();
}
